import Service from './Service'

export default function cService(axiosIns, jwtOverrideConfig) {
  const ddService = new Service(axiosIns, jwtOverrideConfig)

  return {
    ddService
  }
}
